import { Paper, Typography, Grid, FormLabel, Divider, Button, makeStyles, FormControlLabel, Radio, RadioGroup } from "@material-ui/core";
import React, { useContext, useState } from "react";
import { MapOcorrenciasContext } from "./MapaOcorrencias";
import FilterListIcon from '@material-ui/icons/FilterList';

const useStyles = makeStyles(theme => ({
    paper: {
        padding: 10,
        margin: 10,
        textAlign: 'left',
        overflow: 'auto',
        maxHeight: 'calc(100vh - 260px)',
        color: theme.palette.text.secondary,
        cursor: 'pointer',
    },
    formulario: {
        overflow: 'hidden'
    },
    formControl: {
        fontSize: 12,
        marginTop: '-5px',
        padding: '-10px',
    },
    button: {
        marginTop: '20px',
        marginBottom: '20px',
    },

}));

export const Camadas: React.FC = () => {

    const context = useContext(MapOcorrenciasContext);
    const classes = useStyles();
    const [culturaEscolhida, setCulturaEscolhida] = useState<string>('nenhuma');

    const handleChange = (event: any) => {
        const { target: { value: _value } } = event;
        setCulturaEscolhida(_value);
    }
    const aplicarConsulta = async () => {
        context.changeLayer(culturaEscolhida);
    }
    return (
        <>
            <Paper className={classes.paper}>
                <div className={classes.formulario}>
                    <Typography variant='button' align='center' paragraph>Options</Typography>
                    <Grid
                        container
                        spacing={1}
                        direction="row"
                        justify="flex-end"
                        alignItems="flex-start"
                    >
                        <Grid item sm={12}>
                            <FormLabel component="legend">Cultura</FormLabel>
                            <RadioGroup aria-label="cultura" onChange={handleChange} name="row-radio-buttons-group">
                                <FormControlLabel checked={culturaEscolhida === "nenhuma"} value="nenhuma" control={<Radio />} label="Nenhuma" />
                                <FormControlLabel value="algodao" control={<Radio />} label="Algodão" />
                                <FormControlLabel value="arroz" control={<Radio />} label="Arroz" />
                                <FormControlLabel value="cana" control={<Radio />} label="Cana" />
                                <FormControlLabel value="milho" control={<Radio />} label="Milho" />
                                <FormControlLabel value="soja" control={<Radio />} label="Soja" />
                                <FormControlLabel value="trigo" control={<Radio />} label="Trigo" />
                            </RadioGroup>
                        </Grid>
                    </Grid>
                </div>
            </Paper>
            <Divider light />
            <Grid container justify='center'>
                <Button
                    className={classes.button}
                    variant='contained'
                    color='primary'
                    onClick={() => aplicarConsulta()}
                    startIcon={<FilterListIcon />}
                >
                    Aplicar
                </Button>
            </Grid>
        </>
    );
}